import { useMemo, type ReactNode as _ReactNode } from "react";
import { useUser } from "@/providers/use-user";
import { useStreamContext } from "@/providers/Stream";
import { StorageContext } from "./storage-context";

interface StorageProviderProps {
  children: _ReactNode;
  /** Override userId from UserProvider (used in capture mode) */
  overrideUserId?: string;
  /** Override conversationId from StreamContext (used in capture mode) */
  overrideConversationId?: string;
}

export function StorageProvider({
  children,
  overrideUserId,
  overrideConversationId,
}: StorageProviderProps) {
  const { userId: contextUserId } = useUser();
  const stream = useStreamContext();

  const value = useMemo(
    () => ({
      userId: overrideUserId || contextUserId || undefined,
      conversationId: overrideConversationId || stream?.threadId || undefined,
    }),
    [overrideUserId, overrideConversationId, contextUserId, stream?.threadId]
  );

  return <StorageContext.Provider value={value}>{children}</StorageContext.Provider>;
}

// Re-export for convenience
